<template>
    <pop
        customClass="preview-image-pop"
        popMaskClass="preview-image-pop-mask"
        :allowClose="false"
        ref="pop"
        closeClass="close"
        closeIcon="icon-close"
    >
        <div
            class="preview-container"
            :class="theme"
            v-outsidetouchstart="closePop"
        >
            <div
                class="my-swiper-box"
                id="my-swiper-box"
                ref="myWriperBoxRef"
            >
                <swiper
                    :key="index"
                    v-bind="swiperOptions"
                    v-if="sourceList.length"
                    @init="onSwiperReady"
                    @slideChange="slideChange"
                >
                    <slide
                        v-for="(item, i) in sourceList"
                        :key="item.preview + i"
                        class="slide-content swiper-no-swiping"
                    >
                        <div
                            class="gallery-img"
                            :ref="'galleryImgRef' + i"
                        >
                            <site-img
                                :src="item.preview"
                                dir="height"
                                :ref="'imgRef' + i"
                                :style="{
                                    height: getScaleValue + '%'
                                }"
                                @mousedown="
                                    posMove(
                                        $event,
                                        item.type,
                                        i
                                    )
                                "
                            />
                        </div>
                    </slide>
                    <div
                        class="swiper-button-prev iconfont icon-prev"
                    ></div>
                    <div
                        class="swiper-button-next iconfont icon-next"
                    ></div>
                </swiper>
            </div>
            <div class="img-number">{{ currentMediaTabIndex + 1 }}/{{ sourceList.length }}</div>
            <div class="close-box" @click="closePop">
                <span class="iconfont icon-close-light close"></span>
            </div>
        </div>
    </pop>
</template>

<script>
import { Swiper, SwiperSlide, fixSwiperOptions } from '@/common/swiper';
export default {
    i18next: {
        ns: 'md-detail-info'
    },
    components: {
        Swiper,
        Slide: SwiperSlide,
    },
    data: function() {
        return {
            sourceList: [],
            theme: '',
            currentMediaTabIndex: 0,
            scaleValue: 100,
            defaultScaleValue: 100,
            swiper: null
        };
    },
    computed: {
        getScaleValue() {
            return this.scaleValue;
        },
    },
    created() {
        this.swiperOptions = fixSwiperOptions({
            navigation: {
                closest: '.my-swiper-box',
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
                disabledClass: 'disabled'
            }
        });
    },
    methods: {
        onSwiperReady(swiper) {
            this.swiper = swiper;
            this.swiper.slideTo(this.currentMediaTabIndex);
        },
        slideChange(swiper) {
            this.currentMediaTabIndex = swiper.activeIndex;
        },
        init({ index, item, sourceList, theme }) {
            this.sourceList = sourceList || []
            this.theme = theme
            if (!(item instanceof Object)) {
                item = this.sourceList[index];
            }
            let newIndex = this.sourceList.findIndex(
                k =>
                    k.preview == item.preview &&
                    k.type == item.type &&
                    k.url == item.url
            );
            newIndex = newIndex < 0 ? 0 : newIndex;
            this.currentMediaTabIndex = newIndex;
            this.removeImgStyle();
            setTimeout(() => {
                this.swiper && this.swiper.slideTo(newIndex);
            });
        },
        removeImgStyle() {
            let oDiv =
                this?.$refs['imgRef' + this.currentMediaTabIndex]?.[0]?.$el;
            oDiv?.removeAttribute('style');
            this.scaleValue = this.defaultScaleValue;
        },
        // img drag
        posMove(ev, type, getdivid) {
            let oDiv = this?.$refs['imgRef' + getdivid]?.[0]?.$el;
            let oParent = this?.$refs['myWriperBoxRef'];
            if (type == 'img') {
                let oEvent = ev || event;
                let sentX = oEvent.clientX - oDiv.offsetLeft;
                let sentY = oEvent.clientY - oDiv.offsetTop;

                document.onmousemove = function(ev) {
                    let oEvent = ev || event;

                    let slideLeft = oEvent.clientX - sentX;
                    let slideTop = oEvent.clientY - sentY;

                    if (
                        oEvent.clientX > oParent.offsetLeft &&
                        oEvent.clientX <
                            oParent.offsetLeft + oParent.offsetWidth
                    ) {
                        oDiv.style.left = slideLeft + 'px';
                    }
                    if (
                        oEvent.clientY > oParent.offsetTop &&
                        oEvent.clientY <
                            oParent.offsetTop + oParent.offsetHeight
                    ) {
                        oDiv.style.top = slideTop + 'px';
                    }
                };
                document.onmouseup = function() {
                    document.onmousemove = null;
                    document.onmouseup = null;
                };
            }

            return false;
        },
        closePop() {
            this.$refs.pop.close();
        }
    }
};
</script>
<style lang="scss">
.preview-image-pop-mask {
    z-index: var(--level-subhigh);
}
.preview-image-pop {
    z-index: var(--level-subhigh);
    .preview-container {
        width: 100vw;
        height: 100vh;
        background: transparent;
        overflow: hidden;
        position: relative;
        .close-box {
            position: absolute;
            top: 50px;
            right: 50px;
            .close {
                color: #fff;
                font-size: 24px;
            }
        }
        .my-swiper-box {
            overflow: hidden;
            width: 100%;
            height: calc(100vh - 250px);
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            .swiper {
                height: 100%;
                object-fit: cover;
                overflow: hidden;
                .swiper-button-prev,
                .swiper-button-next {
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%);
                    z-index: 10;
                    font-size: 32px;
                    height: 100%;
                    width: 32px;
                    color: rgba(255, 255, 255, 0.8);
                    cursor: pointer;
                    &:hover {
                        color: #fff;
                    }
                    &::after {
                        display: none;
                    }
                    &.disabled {
                        opacity: 0.35;
                        pointer-events: none;
                    }
                }
                .swiper-button-prev {
                    left: 30px;
                }
                .swiper-button-next {
                    right: 30px;
                }
                .gallery-img {
                    height: 100%;
                    text-align: center;
                    position: relative;
                    img {
                        width: calc(100% - 440px);
                        height: 100%;
                        object-fit: cover;
                        transition: 0.3 all ease;
                        -webkit-user-drag: none;
                        position: absolute;
                        left: 50%;
                        top: 50%;
                        transform: translate(-50%, -50%);
                    }
                }
                .slide-content {
                    overflow: hidden;
                    display: flex;
                    flex-direction: column;
                }
            }
        }
        .img-number {
            position: absolute;
            z-index: 10;
            color: #fff;
            bottom: 55px;
            width: 100px;
            left: 50%;
            transform: translateX(-50%);
            text-align: center;
            font-size: 20px;
        }
    }
}
</style>
